export const V1RedirectUrls: V1RedirectUrls = {
    "setup": "Setup/Home",
    "maintenance": "Fleet-Management/Maintenance/Home",
    "fleetTracking": "AssetStatus/LastPosition",
    "fuelManagement": "Manage/Fuel/Dashboard",
    "accountsAndUsers": "Setup/Accounts-And-Users?currentUser=true"
}

export interface V1RedirectUrls {
    [key: string]: string;
}